/** Niedrigster Nachtpreis (Standard + alle Saisons). */
export const nightFrom = (p) => {
  const prices = [Number(p.price_per_night), ...(p.seasons || []).map((s) => Number(s.price_per_night))].filter((n) => n > 0);
  return prices.length ? Math.min(...prices) : Number(p.price_per_night) || 0;
};

/** Wochenpreis zu einem Nachtpreis inkl. Endreinigung (entfällt ab cleaning_waived_from Nächten ≤ 7; „1 Nacht“-Regel nutzt den Nachtpreis) + optional Servicegebühr je Buchung. */
export const weekPrice = (p, night, serviceFee = 0) => {
  const n = Number(night) || 0;
  const waived = Number(p.cleaning_waived_from) > 0 && Number(p.cleaning_waived_from) <= 7;
  const cleaning = waived ? 0 : (p.cleaning_one_night ? n : Number(p.cleaning_fee || 0));
  return Math.round(n * 7 + cleaning + (Number(serviceFee) || 0));
};

export const weekFrom = (p, serviceFee = 0) => weekPrice(p, nightFrom(p), serviceFee);
